import medya1 from "../assets/sosyalMedya1.png";
import medya2 from "../assets/sosyalMedya2.png";
import medya3 from "../assets/sosyalMedya3.png";
import medya4 from "../assets/sosyalMedya4.png";
import medya5 from "../assets/sosyalMedya5.png";

const Medya = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Our Social Media Posts</h2>
        </div>
      </div>

      <div className="row justify-content-md-center">
        <div className="col-md-12 col-sm-12 mt-4 mb-4 table-responsive">
          <table className="table table-light table-bordered table-hover">
            <tbody>
              <tr>
                <td className="py-3 px-4">
                  <a href="https://tr.linkedin.com/posts/polsan-teknokent-y%C3%B6netim-a-%C5%9F_i%C3%A7g%C3%BCvenlik-ilerig%C3%BCvenlikteknolojileri-activity-7383484107940491265-QVz9" target="_blank">
                    <img src={medya1} alt="Medya 1" className="img-fluid mx-4 my-4" />
                  </a>
                </td>
                <td className="py-3 px-4">
                  <a href="https://tr.linkedin.com/posts/polsan-teknokent-y%C3%B6netim-a-%C5%9F_teknokent-%C3%BCniversitesanayii%C5%9Fbirli%C4%9Fi-igef2025-activity-7384126397533007872-l35y" target="_blank">
                    <img src={medya2} alt="Medya 2" className="img-fluid mx-4 my-4" />
                  </a>
                </td>
              </tr>
              <tr>
                {/* <td className="py-3 px-4">
                  <a href="https://tr.linkedin.com/posts/polsan-teknokent-y%C3%B6netim-a-%C5%9F_29ekim-cumhuriyetbayram%C4%B1-activity-7389226982414327808-MSF_" target="_blank">
                    <img src={medya3} alt="Medya 3" className="img-fluid mx-4 my-4" />
                  </a>
                </td> */}
                <td className="py-3 px-4">
                  <a href="https://tr.linkedin.com/posts/polsan-teknokent-y%C3%B6netim-a-%C5%9F_polsanteknokent-mimariyar%C4%B1%C5%9Fma-kentseltasar%C4%B1m-activity-7391455193990721536-jvbR" target="_blank">
                    <img src={medya4} alt="Medya 4" className="img-fluid mx-4 my-4" />
                  </a>
                </td>
              </tr>
              {/* <tr>
                <td className="py-3 px-4">
                  <a href="https://www.linkedin.com/posts/polsan-teknokent-y%C3%B6netim-a-%C5%9F_10kas%C4%B1m-activity-7393544992813846529-LGGj" target="_blank">
                    <img src={medya5} alt="Medya 5" className="img-fluid mx-4 my-4" />
                  </a>
                </td>
              </tr> */}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Medya;
